const params = [
  {
    programs: "Digital Publishing",
    value: 0,
  },
];

export default params;
